<template>
  <div>
    <p class="text-center">
      <a
        v-if="downloadUrl != ''"
        :href="downloadUrl"
        class="btn btn-primary btn-lg"
        >View and Print Pass/Permit
        <font-awesome-icon icon="chevron-right" class="fa fa-fw"
      /></a>
      <br />
      <router-link :to="{ name: 'home' }">
        <font-awesome-icon icon="home" class="fa fa-fw" /> Return to YourPassNow
      </router-link>
    </p>
  </div>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronRight, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faChevronRight);
library.add(faHome);

export default {
  components: {
    FontAwesomeIcon
  },
  name: "ReceiptButtons",
  props: ["downloadUrl"]
};
</script>
